import './styles.sass';

import React, { useEffect, useRef } from 'react';

import Transition from 'components/Explorer/Transition';
import Spinner from 'components/Explorer/Spinner';
import PageTitle from 'components/Explorer/PageTitle';
import Pagination from 'components/Explorer/Pagination';
import useExplorerData, { Loading } from 'hooks/useExplorerData';

import FilterPanel from './FilterPanel';
import MentionSource from './MentionSource';
import SortBy from './SortBy';
import Summary from './Summary';
import useQueryParams from 'hooks/useQueryParams';

const trackPageChange = (page) => {
  Analytics.trackEvent('paginate-mention-author', { page });
};

const MentionSources = () => {
  const params = useQueryParams();
  const rootRef = useRef(null);

  const { data, loading, status } = useExplorerData('mention_sources', params, {
    reloadOn: ['filters', 'page', 'mentionSourceOrder']
  });

  useEffect(() => {
    if (loading === Loading.SUCCESS || loading === Loading.ERROR || loading === Loading.EMPTY_RESPONSE) {
      const wrapper = rootRef.current?.closest('.Explorer-ContentPanel');
      if (wrapper) wrapper.scrollTop = 0;
    }
  }, [loading]);

  const mentionSources = data?.data ?? [];
  const lastPage = data?.lastPage ?? true;
  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const loadingFailed = loading === Loading.ERROR;
  const hasResults = mentionSources.length > 0;

  const content = () => {
    if (isLoading) return <Spinner key="spinner" />;
    if (loadingFailed) {
      return status === 403 ? I18n.t('Explorer.forbidden_error') : I18n.t('Explorer.loading_error');
    }
    return (
      <>
        <SortBy />
        <Pagination lastPage={lastPage} onChangePage={trackPageChange} />
        {hasResults ? (
          <div>
            {mentionSources.map((mentionSource) => (
              <MentionSource mentionSource={mentionSource} key={mentionSource.id} />
            ))}
          </div>
        ) : (
          <div className="Explorer-MentionSources-empty-message">{I18n.t('Explorer.MentionSources.empty')}</div>
        )}
        <Pagination lastPage={lastPage} onChangePage={trackPageChange} />
      </>
    );
  };

  return (
    <div ref={rootRef} className="Explorer-MentionSources">
      <PageTitle metaTitle={I18n.t('Explorer.TabBar.mention_sources')} />
      <FilterPanel />
      <Summary />

      <Transition>
        <div key="content" className="Explorer-MentionSources-Container">
          {content()}
        </div>
      </Transition>
    </div>
  );
};

export default MentionSources;
